import {
  makeStyles,
  Container,
  Modal,
  Grid,
  Typography,
} from "@material-ui/core";
import { CancelButton, PrimaryButton } from '../components-atoms';
interface IProps {
  open: boolean;
  onClose: () => void;
  onDeactivate: () => void;
}
export const DeactivateCodeModal = ({ open, onClose, onDeactivate }: IProps) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      onClose={onClose}
      className={classes.modal}
    >
      <Container className={classes.modalContainer}>
        <Grid container spacing={1}></Grid>
        <Grid item className={classes.titleSection}>
          <Typography variant="h6" component="h6" color="textPrimary">
            Referral Code
          </Typography>
        </Grid>
        <Grid item className={classes.bodySection}>
          <Typography
            variant="body2"
            component="p"
            className={classes.mt8}
            color="textPrimary"
          >
            Are you sure you want to deactivate this user's referral code?
          </Typography>
        </Grid>
        <Grid item container xs={12} justifyContent="flex-end">
          <CancelButton onClick={onClose} />
          <PrimaryButton
            title="Deactivate"
            onClick={onDeactivate}
            style={{ width: 120, marginLeft: 8 }}
          />
        </Grid>
      </Container>
    </Modal>
  );
};
const useStyles = makeStyles({
  modal: { alignItems: "center", justifyContent: "center" },
  modalContainer: {
    backgroundColor: "white",
    maxWidth: "480px",
    boxShadow:
      "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
    borderRadius: "20px",
    padding: "24px",
    margin: "0",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  deactivateButton: {
    width: 180
  },
  titleSection: {
    marginBottom: "8px",
  },
  bodySection: {
    marginBottom: "52px",
  },
  mt8: {
    marginTop: 8,
  },
});
